import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    content: {
        [theme.breakpoints.up('md')]: {
            padding: '10px'
        },
        overflowY: 'auto',
    }
});

class ScrolledContent extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div ref={this.getTopPosition}
                className={classes.content}
            >
                {this.props.children}
            </ div>
        );
    }
}

export default withStyles(styles)(ScrolledContent);